module.exports = __webpack_public_path__ + "catalog/items/firesafety/Location-Green/Location-Green.svg";